import styles from './QuantityInput.module.scss'
import React from 'react'

type Props = {
  value: number,
  max?: number,
  min?: number,
  onChange: (value: number) => void
}

const QuantityInput = (props: Props) => {
  const [value, setValue] = React.useState<number|null>(props.value)

  // method to increment or decrement the value
  const changeValue = (method: 'increase' | 'decrease') => {
    let newValue = props.value
    if (method === 'increase') {
      newValue = props.value + 1
    } else {
      newValue = props.value - 1
    }

    if (props.max && newValue > props.max) {
      newValue = props.max
    }

    if (props.min && newValue < props.min) {
      newValue = props.min
    }

    props.onChange(newValue)
  }

  const onIncrease = () => {
    changeValue('increase')
  }

  const onDecrease = () => {
    changeValue('decrease')
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value) || null
    setValue(newValue)
  }

  const onBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value)
    props.onChange(newValue)
  }

  React.useEffect(() => {
    setValue(props.value)
  }, [props.value])

  return (
    <div className={styles.component}>
      <button onClick={onDecrease}>-</button>
      <div className={styles.number}>
        <input
          value={value || ''}
          onBlur={onBlur}
          onChange={onChange}
        />
      </div>
      <button onClick={onIncrease}>+</button>
    </div>
  )
}

export default QuantityInput